import { N06_01 } from "./N06_01";

export const N06 = {
  columns: 12,
  rows: 2,
  visual: {
    id: 1,
    type: "advancedTable",
    colorTheme: "colorTheme1",
    title: "Coverage by Regional Sales Manager",
    binding: {
      data: {
        columns: [
          {
            name: "Code",
            columnName: "AgentCode",
            width: "120px",
            align: "left",
            sortable: true,
          },
          {
            name: "Name",
            columnName: "EmployeeName",
            width: "220px",
            align: "left",
            sortable: true,
          },
          {
            name: "Call Rate",
            columnName: "CallRate",
            width: "150px",
            align: "center",
            sortable: true,
            percent: true,
          },
          {
            name: "Call Reach",
            columnName: "CallReach",
            width: "150px",
            align: "center",
            sortable: true,
            percent: true,
          },
          {
            name: "Call Frequency",
            columnName: "CallFrequency",
            width: "170px",
            align: "center",
            sortable: true,
            percent: true,
          },
          {
            name: "Average Calls",
            columnName: "AvgCallsPerDay",
            width: "170px",
            align: "center",
            sortable: true,
          },
          {
            name: "Regular Calls",
            columnName: "RegularCalls",
            width: "170px",
            align: "center",
            sortable: true,
          },
          {
            name: "Advanced Calls",
            columnName: "AdvancedCalls",
            width: "170px",
            align: "center",
            sortable: true,
          },
          {
            name: "Recovered Calls",
            columnName: "RecoveredCalls",
            width: "170px",
            align: "center",
            sortable: true,
          },
          {
            name: "Missed Calls",
            columnName: "MissedCalls",
            width: "170px",
            align: "center",
            sortable: true,
          },
          {
            name: "Incidental Calls",
            columnName: "IncidentalCalls",
            width: "170px",
            align: "center",
            sortable: true,
          },
        ],
        title: "EmployeeName",
        endpoint: "N06",
        parameters: [
          { key: "CycleCode", value: "CP1" },
          { key: "CycleYear", value: "2026" },
        ],
      },
      context: {
        point: {
          onClick: N06_01,
        },
      },
    },
  },
};
